import type { BadgeType } from '@designSystem/components'

export const Statut = [
  'EnCoursAnalyse',
  'AttentePieces',
  'Cloture',
  'Valide',
  'Rejete',
  'Transmis',
  'EnCoursDePaiement',
  'Payee',
  'ProformaTransmise',
  'PayeSurAcompte',
] as const

export type Statut = (typeof Statut)[number]

export const StatutLibelle: Record<Statut, string> = {
  EnCoursAnalyse: 'En cours d\'analyse',
  Cloture: 'Clôturé',
  Transmis: 'Transmis',
  Rejete: 'Rejeté',
  Valide: 'Validée',
  AttentePieces: 'En attente pièces',
  EnCoursDePaiement: 'En cours de paiement',
  Payee: 'Payée',
  ProformaTransmise: 'Proforma transmise',
  PayeSurAcompte: 'Payée sur acompte',
}

export const StatutBadgeType: Record<Statut, BadgeType> = {
  EnCoursAnalyse: 'pending',
  Cloture: 'success',
  Valide: 'success',
  Rejete: 'error',
  Transmis: 'info',
  AttentePieces: 'pending',
  EnCoursDePaiement: 'pending',
  Payee: 'success',
  ProformaTransmise: 'info',
  PayeSurAcompte: 'success',
} as const
